(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-add-ons"] && !Shopify.designMode) return;
  try {
    class ProductAddOns extends HTMLElement {
    constructor() {
      super();
      this.modal = this.querySelector('dialog');
      this.modalItems = this.querySelectorAll('[data-modal-item]');
      this.modalTriggers = this.querySelectorAll('.product-add-on__modal-trigger');
      this.dropdowns = this.querySelectorAll('.product-add-on__variant-dropdown');
      this.atcButtons = this.querySelectorAll('.product-add-on__atc-button');
      
      this.bindEvents();
    }
    
    bindEvents() {
      // Prevent slideshow from capturing pointer events on interactive elements
      this.querySelectorAll('.product-add-on__variant-dropdown, .product-add-on__atc-button').forEach(el => {
        el.addEventListener('pointerdown', (e) => e.stopPropagation());
        el.addEventListener('mousedown', (e) => e.stopPropagation());
        el.addEventListener('touchstart', (e) => e.stopPropagation(), { passive: true });
      });

      this.modalTriggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
          const index = e.currentTarget.dataset.modalIndex;
          this.openModal(index);
        });
      });
      
      this.dropdowns.forEach(dropdown => {
        dropdown.addEventListener('change', (e) => {
          const parent = e.currentTarget.closest('.product-add-on');
          const atcButton = parent.querySelector('.product-add-on__atc-button');
          const image = parent.querySelector('.product-add-on__image img');
          const selectedOption = e.currentTarget.selectedOptions[0];
          
          // Update variant ID on ATC button
          if (atcButton) {
            atcButton.dataset.variantId = selectedOption.value;
          }
          
          // Update product image if variant has one
          if (image && selectedOption.dataset.variantImage) {
            image.src = selectedOption.dataset.variantImage;
            if (selectedOption.dataset.variantImageSrcset) {
              image.srcset = selectedOption.dataset.variantImageSrcset;
            }
          }
        });
      });
      
      this.atcButtons.forEach(button => {
        // Skip auto-add (gift) buttons
        if (button.dataset.autoAdd === 'true') return;
        
        button.addEventListener('click', (e) => {
          const btn = e.currentTarget;
          if (btn.disabled) return;
          
          const variantId = btn.dataset.variantId;
          if (!variantId) return;
          
          this.addToCart(variantId, btn);
        });
      });

      // Auto-add gift items on page load
      this.atcButtons.forEach(button => {
        if (button.dataset.autoAdd === 'true') {
          const variantId = button.dataset.variantId;
          if (variantId) {
            this.addToCart(variantId, button);
          }
        }
      });
    }
    
    async addToCart(variantId, button) {
      const originalText = button.textContent;
      button.disabled = true;
      button.textContent = 'Adding...';
      
      try {
        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');

        const response = await fetch(window.Theme?.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/javascript',
          },
          body: formData,
        });
        
        if (!response.ok) {
          throw new Error('Failed to add to cart');
        }

        const responseData = await response.json().catch(() => ({}));
        
        button.textContent = 'Added!';
        button.classList.add('product-add-on__atc-button--added');
        
        // Dispatch cart:update event matching the Horizon theme's CartAddEvent structure
        // This updates the cart icon, cart drawer, and any other listeners
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: responseData,
            sourceId: variantId,
            data: {
              source: 'product-form-component',
              itemCount: 1,
              productId: button.closest('.product-add-on')?.dataset?.addonIndex,
              sections: responseData.sections || {},
            },
          },
        }));
        
        // Reset button after delay
        setTimeout(() => {
          button.textContent = originalText;
          button.classList.remove('product-add-on__atc-button--added');
          button.disabled = false;
        }, 2000);
        
      } catch (error) {
        console.error('Add-on cart error:', error);
        button.textContent = 'Try again';
        setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
        }, 2000);
      }
    }
    
    openModal(index) {
      if (!this.modal) return;
      
      this.modalItems.forEach(item => {
        item.hidden = item.dataset.modalItem !== index;
      });
      
      this.modal.showModal();
    }
  }
  
  customElements.define('product-add-ons', ProductAddOns);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-size-selector"] && !Shopify.designMode) return;
  try {
    class ProductSizeSelector {
    constructor() {
      this.init();
    }

    init() {
      document.querySelectorAll('[data-size-drawer-trigger]').forEach(trigger => {
        const blockId = trigger.dataset.sizeDrawerTrigger;
        const drawer = document.querySelector(`[data-size-drawer="${blockId}"]`);
        
        if (!drawer) return;

        trigger.addEventListener('click', () => {
          drawer.showModal();
        });

        const closeBtn = drawer.querySelector('[data-close-size-drawer]');
        if (closeBtn) {
          closeBtn.addEventListener('click', () => this.closeDrawer(drawer));
        }

        drawer.addEventListener('click', (e) => {
          if (e.target === drawer) {
            this.closeDrawer(drawer);
          }
        });

        drawer.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') {
            e.preventDefault();
            this.closeDrawer(drawer);
          }
        });
      });

      document.querySelectorAll('[data-compare-drawer-trigger]').forEach(trigger => {
        const blockId = trigger.dataset.compareDrawerTrigger;
        const drawer = document.querySelector(`[data-compare-drawer="${blockId}"]`);
        
        if (!drawer) return;

        trigger.addEventListener('click', () => {
          drawer.showModal();
        });
      });
    }

    closeDrawer(drawer) {
      drawer.classList.add('dialog-closing');
      setTimeout(() => {
        drawer.close();
        drawer.classList.remove('dialog-closing');
      }, 300);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new ProductSizeSelector());
  } else {
    new ProductSizeSelector();
  }
  } catch(e) { console.error(e); }
})();

})();
